import React, { memo, useCallback, useState } from "react";
import { MenuIcon } from "components/AppHeader/Mobile/MobileHeader";
import { MdShoppingCart } from "react-icons/md";
import MobileCartDropdown from "./MobileCartDropdown";
import { DefaultText } from "theme/GlobalElements";
import styled from "styled-components/macro";
import { Counter } from "./DesktopCartButton";
import { selectCartReload, updateCartData } from "./cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { toRem } from "theme/Breakpoints";
import { HiOutlineShoppingCart } from "react-icons/hi";
import userStorage from "store/UserStorage";
import { ProductCartItem } from "./types";

interface Props {}
const MobileCartButton: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const [isToggled, setToggled] = useState(false);
  const count = userStorage.selectTotalSelectedItems();
  const reload = useSelector(selectCartReload);
  const cartItems = userStorage.getStoredInCart();
  const onToggleClick = () => {
    setToggled(!isToggled);
  };

  const onClickOutside = useCallback(() => {
    setToggled(false);
  }, []);

  const updateData = (newProductCardItems: any) => {
    dispatch(updateCartData([...newProductCardItems]));
  };

  const removeElementWithId = (id: string) => {
    if (cartItems.length !== 0) {
      let newListedItems = [...cartItems];
      let element = cartItems.find((c: ProductCartItem) => c.product._id === id);
      if (element) {
        let index = cartItems.indexOf(element);
        newListedItems.splice(index, 1);
        updateData([...newListedItems]);
      }
    }
  };

  return (
    <Wrapper>
      {isToggled && (
        <MobileCartDropdown
          emptyMessage="Количката ви е празна!"
          actionButtonTitle="Към количката"
          removeElementWithId={removeElementWithId}
          actionButtonIcon={
            <HiOutlineShoppingCart
              style={{
                width: 24,
                height: 24,
                color: "white",
                marginRight: "5px",
              }}
            />
          }
          actionButtonRoute="/cart"
          onClickOutside={onClickOutside}
          updateCallback={updateData}
          items={cartItems}
        />
      )}
      <Container onClick={onToggleClick}>
        <MenuIcon>
          <MdShoppingCart color="white" size="2em" />
        </MenuIcon>
        <MobileCounter>
          <DefaultText color={"white"}>{count}</DefaultText>
        </MobileCounter>
      </Container>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  height: ${toRem(50)};
  width: ${toRem(50)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const MobileCounter = styled(Counter)`
  top: 3px;
  right: 3px;
`;

export default memo(MobileCartButton);
